/**
 * When opening channel edit / applying channelUpdated, FIND/SET can overwrite the
 * store channel with an API payload. Superadmin (and member-channels list) hydrate
 * with isMember:true so channels stay in the sidebar; payloads may report false
 * when the user is not a direct member. Keep visibility if we already had the
 * channel as a member in the list.
 *
 * Use forceLeave (e.g. channelClosed) when membership must become false.
 */
export const resolveChannelIsMember = ({
  existingIsMember,
  incomingIsMember,
  forceLeave = false,
}) => {
  if (forceLeave) return false;
  return Boolean(existingIsMember || incomingIsMember);
};

/** @deprecated Prefer resolveChannelIsMember — kept for call-site clarity on find. */
export const preserveIsMemberOnFind = (existingIsMember, payloadIsMember) =>
  resolveChannelIsMember({
    existingIsMember,
    incomingIsMember: payloadIsMember,
  });
